// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/dbe99020360a24fe6248.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d45e65b124620d1ef73d","148":"57320d5d62a48a38aeba","149":"910efdfc084c7bd25304"}[chunkId] + ".chunk.js";
};